// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.dev.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  okta: {
    clientId: '#{oktaclientid}#',
    issuerURL: '#{oktadomain}#' + '/oauth2/default',
    redirectURI: window.location.origin + '/implicit/callback',
    endSessionRedirectURI: window.location.origin + '/logout',
    scopes: ['openid profile email groups'],
    pkce: true
  },
  configURI: '#{configURI}#',
  downloadURI: '#{downloadURI}#',
  stateURL: '#{stateURL}#',
  stateRequirmentURL: '#{stateRequirmentURL}#',
  uploadServiceURL: '#{uploadServiceURL}#',
  downloadServiceURL1: '#{downloadServiceURL1}#',
  analyticsID: '#{analyticsID}#',
  ComplaintsTrackingID: '#{ComplaintsTrackingID}#',
  browserIdleTime: 1800,
  timeOut: 1,
  ping:120,
  Roles: '#{Roles}#',
  allTabs: ['Dashboard', 'Summary', 'Location', 'Due Diligence', 'Insurance', 'License', 'Employees', 'State Requirements', 'Change Log'],
  clientTabs: ['Dashboard', 'Summary', 'Location', 'Due Diligence', 'Insurance', 'License', 'Employees', 'State Requirements'],
  vendorTabs: ['Dashboard', 'Summary', 'Location', 'Due Diligence', 'Insurance', 'License', 'Employees', 'State Requirements','Complaints'],
  videoFileFormats: ['video/mp4', 'video/quicktime', 'video/x-flv', 'video/avi', 'video/x-ms-wmv'],
  videoFileTypes: ['mp4', 'flv', 'avi', 'wmv', 'mov'],
  locationTabs: ['Location Summary', 'Documents'],
  locationCheckList : ['Location Summary', 'Documents', 'Checklist'],
  googleAnalyticsEvents: ['Add Complaint','Edit Complaint','Delete Complaint','Add Task','Edit Task','Delete Task','Add Relate Complaint','Add Document','Download Document','Delete Document'],
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts